'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getKeysOfEnumerableProperties = (object) => {
    const keys = Object.keys(object).sort();
    if (Object.getOwnPropertySymbols) {
        Object.getOwnPropertySymbols(object).forEach(symbol => {
            if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) {
                keys.push(symbol);
            }
        });
    }
    return keys;
};
function printIteratorEntries(iterator, config, indentation, depth, refs, printer, separator = ': ') {
    let result = '';
    let current = iterator.next();
    if (!current.done) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        while (!current.done) {
            const name = printer(current.value[0], config, indentationNext, depth, refs);
            const value = printer(current.value[1], config, indentationNext, depth, refs);
            result += indentationNext + name + separator + value;
            current = iterator.next();
            if (!current.done) {
                result += ',' + config.spacingInner;
            }
            else if (!config.min) {
                result += ',';
            }
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
function printIteratorValues(iterator, config, indentation, depth, refs, printer) {
    let result = '';
    let current = iterator.next();
    if (!current.done) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        while (!current.done) {
            result += indentationNext + printer(current.value, config, indentationNext, depth, refs);
            current = iterator.next();
            if (!current.done) {
                result += ',' + config.spacingInner;
            }
            else if (!config.min) {
                result += ',';
            }
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
function printListItems(list, config, indentation, depth, refs, printer) {
    let result = '';
    if (list.length) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        for (let i = 0; i < list.length; i++) {
            result += indentationNext + printer(list[i], config, indentationNext, depth, refs);
            if (i < list.length - 1) {
                result += ',' + config.spacingInner;
            }
            else if (!config.min) {
                result += ',';
            }
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
function printObjectProperties(val, config, indentation, depth, refs, printer) {
    let result = '';
    const keys = getKeysOfEnumerableProperties(val);
    if (keys.length) {
        result += config.spacingOuter;
        const indentationNext = indentation + config.indent;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const name = printer(key, config, indentationNext, depth, refs);
            const value = printer(val[key], config, indentationNext, depth, refs);
            result += indentationNext + name + ': ' + value;
            if (i < keys.length - 1) {
                result += ',' + config.spacingInner;
            }
            else if (!config.min) {
                result += ',';
            }
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}

const ansiRegex = require('ansi-regex');
const style$1 = require('ansi-styles');
const toHumanReadableAnsi = (text) => text.replace(ansiRegex(), match => {
    switch (match) {
        case style$1.red.close:
        case style$1.green.close:
        case style$1.cyan.close:
        case style$1.gray.close:
        case style$1.white.close:
        case style$1.yellow.close:
        case style$1.bgRed.close:
        case style$1.bgGreen.close:
        case style$1.bgYellow.close:
        case style$1.inverse.close:
        case style$1.dim.close:
        case style$1.bold.close:
        case style$1.reset.open:
        case style$1.reset.close:
            return '</>';
        case style$1.red.open:
            return '<red>';
        case style$1.green.open:
            return '<green>';
        case style$1.cyan.open:
            return '<cyan>';
        case style$1.gray.open:
            return '<gray>';
        case style$1.white.open:
            return '<white>';
        case style$1.yellow.open:
            return '<yellow>';
        case style$1.bgRed.open:
            return '<bgRed>';
        case style$1.bgGreen.open:
            return '<bgGreen>';
        case style$1.bgYellow.open:
            return '<bgYellow>';
        case style$1.inverse.open:
            return '<inverse>';
        case style$1.dim.open:
            return '<dim>';
        case style$1.bold.open:
            return '<bold>';
        default:
            return '';
    }
});
const test$2 = (val) => typeof val === 'string' && !!val.match(ansiRegex());
const serialize$2 = (val, config, indentation, depth, refs, printer) => printer(toHumanReadableAnsi(val), config, indentation, depth, refs);
const plugin$2 = { serialize: serialize$2, test: test$2 };

const SPACE = ' ';
const OBJECT_NAMES = ['DOMStringMap', 'NamedNodeMap'];
const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;
const testName = (name) => OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);
const test$1 = (val) => val && val.constructor && !!val.constructor.name && testName(val.constructor.name);
const isNamedNodeMap = (collection) => collection.constructor.name === 'NamedNodeMap';
const serialize$1 = (collection, config, indentation, depth, refs, printer) => {
    const name = collection.constructor.name;
    if (++depth > config.maxDepth) {
        return '[' + name + ']';
    }
    return ((config.min ? '' : name + SPACE) +
        (OBJECT_NAMES.indexOf(name) !== -1
            ? '{' +
                printObjectProperties(isNamedNodeMap(collection)
                    ? Array.from(collection).reduce((props, attribute) => {
                        props[attribute.name] = attribute.value;
                        return props;
                    }, {})
                    : Object.assign({}, collection), config, indentation, depth, refs, printer) +
                '}'
            : '[' + printListItems(Array.from(collection), config, indentation, depth, refs, printer) + ']'));
};
const plugin$1 = { serialize: serialize$1, test: test$1 };

function escapeHTML(str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

const printProps = (keys, props, config, indentation, depth, refs, printer) => {
    const indentationNext = indentation + config.indent;
    const colors = config.colors;
    return keys
        .map(key => {
        const value = props[key];
        let printed = printer(value, config, indentationNext, depth, refs);
        if (typeof value !== 'string') {
            if (printed.indexOf('\n') !== -1) {
                printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
            }
            printed = '{' + printed + '}';
        }
        return (config.spacingInner +
            indentation +
            colors.prop.open +
            key +
            colors.prop.close +
            '=' +
            colors.value.open +
            printed +
            colors.value.close);
    })
        .join('');
};
const printChildren = (children, config, indentation, depth, refs, printer) => children
    .map(child => config.spacingOuter +
    indentation +
    (typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs)))
    .join('');
const printText = (text, config) => {
    const contentColor = config.colors.content;
    return contentColor.open + escapeHTML(text) + contentColor.close;
};
const printComment = (comment, config) => {
    const commentColor = config.colors.comment;
    return commentColor.open + '<!--' + escapeHTML(comment) + '-->' + commentColor.close;
};
const printElement = (type, printedProps, printedChildren, config, indentation) => {
    const tagColor = config.colors.tag;
    return (tagColor.open +
        '<' +
        type +
        (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) +
        (printedChildren
            ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type
            : (printedProps && !config.min ? '' : ' ') + '/') +
        '>' +
        tagColor.close);
};
const printElementAsLeaf = (type, config) => {
    const tagColor = config.colors.tag;
    return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
};

const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const COMMENT_NODE = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testNode = (val) => {
    const constructorName = val.constructor.name;
    const { nodeType, tagName } = val;
    const isCustomElement = (typeof tagName === 'string' && tagName.includes('-')) ||
        (typeof val.hasAttribute === 'function' && val.hasAttribute('is'));
    return ((nodeType === ELEMENT_NODE && (ELEMENT_REGEXP.test(constructorName) || isCustomElement)) ||
        (nodeType === TEXT_NODE && constructorName === 'Text') ||
        (nodeType === COMMENT_NODE && constructorName === 'Comment') ||
        (nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment'));
};
const test = (val) => { var _a; return ((_a = val === null || val === void 0 ? void 0 : val.constructor) === null || _a === void 0 ? void 0 : _a.name) && testNode(val); };
function nodeIsText(node) {
    return node.nodeType === TEXT_NODE;
}
function nodeIsComment(node) {
    return node.nodeType === COMMENT_NODE;
}
function nodeIsFragment(node) {
    return node.nodeType === FRAGMENT_NODE;
}
const serialize = (node, config, indentation, depth, refs, printer) => {
    if (nodeIsText(node)) {
        return printText(node.data, config);
    }
    if (nodeIsComment(node)) {
        return printComment(node.data, config);
    }
    const type = nodeIsFragment(node) ? `DocumentFragment` : node.tagName.toLowerCase();
    if (++depth > config.maxDepth) {
        return printElementAsLeaf(type, config);
    }
    return printElement(type, printProps(nodeIsFragment(node)
        ? []
        : Array.from(node.attributes)
            .map(attr => attr.name)
            .sort(), nodeIsFragment(node)
        ? {}
        : Array.from(node.attributes).reduce((props, attribute) => {
            props[attribute.name] = attribute.value;
            return props;
        }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
};
const plugin = { serialize, test };

const style = require('ansi-styles');
const toString = Object.prototype.toString;
const toISOString = Date.prototype.toISOString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const getConstructorName = (val) => (typeof val.constructor === 'function' && val.constructor.name) || 'Object';
const isWindow = (val) => typeof window !== 'undefined' && val === window;
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
const NEWLINE_REGEXP = /\n/gi;
class PrettyFormatPluginError extends Error {
    constructor(message, stack) {
        super(message);
        this.stack = stack;
        this.name = this.constructor.name;
    }
}
function isToStringedArrayType(toStringed) {
    return (toStringed === '[object Array]' ||
        toStringed === '[object ArrayBuffer]' ||
        toStringed === '[object DataView]' ||
        toStringed === '[object Float32Array]' ||
        toStringed === '[object Float64Array]' ||
        toStringed === '[object Int8Array]' ||
        toStringed === '[object Int16Array]' ||
        toStringed === '[object Int32Array]' ||
        toStringed === '[object Uint8Array]' ||
        toStringed === '[object Uint8ClampedArray]' ||
        toStringed === '[object Uint16Array]' ||
        toStringed === '[object Uint32Array]');
}
function printNumber(val) {
    return Object.is(val, -0) ? '-0' : String(val);
}
function printBigInt(val) {
    return String(`${val}n`);
}
function printFunction(val, printFunctionName) {
    if (!printFunctionName) {
        return '[Function]';
    }
    return '[Function ' + (val.name || 'anonymous') + ']';
}
function printSymbol(val) {
    return String(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
}
function printError(val) {
    return '[' + errorToString.call(val) + ']';
}
function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
    if (val === true || val === false) {
        return '' + val;
    }
    if (val === undefined) {
        return 'undefined';
    }
    if (val === null) {
        return 'null';
    }
    const typeOf = typeof val;
    if (typeOf === 'number') {
        return printNumber(val);
    }
    if (typeOf === 'bigint') {
        return printBigInt(val);
    }
    if (typeOf === 'string') {
        if (escapeString) {
            return '"' + val.replace(/"|\\/g, '\\$&') + '"';
        }
        return '"' + val + '"';
    }
    if (typeOf === 'function') {
        return printFunction(val, printFunctionName);
    }
    if (typeOf === 'symbol') {
        return printSymbol(val);
    }
    const toStringed = toString.call(val);
    if (toStringed === '[object WeakMap]') {
        return 'WeakMap {}';
    }
    if (toStringed === '[object WeakSet]') {
        return 'WeakSet {}';
    }
    if (toStringed === '[object Function]' || toStringed === '[object GeneratorFunction]') {
        return printFunction(val, printFunctionName);
    }
    if (toStringed === '[object Symbol]') {
        return printSymbol(val);
    }
    if (toStringed === '[object Date]') {
        return isNaN(+val) ? 'Date { NaN }' : toISOString.call(val);
    }
    if (toStringed === '[object Error]') {
        return printError(val);
    }
    if (toStringed === '[object RegExp]') {
        if (escapeRegex) {
            return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
        }
        return regExpToString.call(val);
    }
    if (val instanceof Error) {
        return printError(val);
    }
    return null;
}
function printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON) {
    if (refs.indexOf(val) !== -1) {
        return '[Circular]';
    }
    refs = refs.slice();
    refs.push(val);
    const hitMaxDepth = ++depth > config.maxDepth;
    const min = config.min;
    if (config.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON === 'function' && !hasCalledToJSON) {
        return printer(val.toJSON(), config, indentation, depth, refs, true);
    }
    const toStringed = toString.call(val);
    if (toStringed === '[object Arguments]') {
        return hitMaxDepth
            ? '[Arguments]'
            : (min ? '' : 'Arguments ') + '[' + printListItems(val, config, indentation, depth, refs, printer) + ']';
    }
    if (isToStringedArrayType(toStringed)) {
        return hitMaxDepth
            ? '[' + val.constructor.name + ']'
            : (min ? '' : val.constructor.name + ' ') +
                '[' +
                printListItems(val, config, indentation, depth, refs, printer) +
                ']';
    }
    if (toStringed === '[object Map]') {
        return hitMaxDepth
            ? '[Map]'
            : 'Map {' + printIteratorEntries(val.entries(), config, indentation, depth, refs, printer, ' => ') + '}';
    }
    if (toStringed === '[object Set]') {
        return hitMaxDepth
            ? '[Set]'
            : 'Set {' + printIteratorValues(val.values(), config, indentation, depth, refs, printer) + '}';
    }
    return hitMaxDepth || isWindow(val)
        ? '[' + getConstructorName(val) + ']'
        : (min ? '' : getConstructorName(val) + ' ') +
            '{' +
            printObjectProperties(val, config, indentation, depth, refs, printer) +
            '}';
}
function isNewPlugin(plugin) {
    return plugin.serialize != null;
}
function printPlugin(plugin, val, config, indentation, depth, refs) {
    let printed;
    try {
        printed = isNewPlugin(plugin)
            ? plugin.serialize(val, config, indentation, depth, refs, printer)
            : plugin.print(val, valChild => printer(valChild, config, indentation, depth, refs), str => {
                const indentationNext = indentation + config.indent;
                return indentationNext + str.replace(NEWLINE_REGEXP, '\n' + indentationNext);
            }, {
                edgeSpacing: config.spacingOuter,
                min: config.min,
                spacing: config.spacingInner,
            }, config.colors);
    }
    catch (error) {
        throw new PrettyFormatPluginError(error.message, error.stack);
    }
    if (typeof printed !== 'string') {
        throw new Error(`pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`);
    }
    return printed;
}
function findPlugin(plugins, val) {
    for (let p = 0; p < plugins.length; p++) {
        try {
            if (plugins[p].test(val)) {
                return plugins[p];
            }
        }
        catch (error) {
            throw new PrettyFormatPluginError(error.message, error.stack);
        }
    }
    return null;
}
function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
    const plugin = findPlugin(config.plugins, val);
    if (plugin !== null) {
        return printPlugin(plugin, val, config, indentation, depth, refs);
    }
    const basicResult = printBasicValue(val, config.printFunctionName, config.escapeRegex, config.escapeString);
    if (basicResult !== null) {
        return basicResult;
    }
    return printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON);
}
const DEFAULT_THEME = {
    comment: 'gray',
    content: 'reset',
    prop: 'yellow',
    tag: 'cyan',
    value: 'green',
};
const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
const DEFAULT_OPTIONS = {
    callToJSON: true,
    escapeRegex: false,
    escapeString: true,
    highlight: false,
    indent: 2,
    maxDepth: Infinity,
    min: false,
    plugins: [],
    printFunctionName: true,
    theme: DEFAULT_THEME,
};
function validateOptions(options) {
    Object.keys(options).forEach(key => {
        if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
            throw new Error(`pretty-format: Unknown option "${key}".`);
        }
    });
    if (options.min && options.indent !== undefined && options.indent !== 0) {
        throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
    }
    if (options.theme !== undefined) {
        if (options.theme === null) {
            throw new Error(`pretty-format: Option "theme" must not be null.`);
        }
        if (typeof options.theme !== 'object') {
            throw new Error(`pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`);
        }
    }
}
const getColorsHighlight = (options) => DEFAULT_THEME_KEYS.reduce((colors, key) => {
    const value = options.theme && options.theme[key] !== undefined ? options.theme[key] : DEFAULT_THEME[key];
    const color = value && style[value];
    if (color && typeof color.close === 'string' && typeof color.open === 'string') {
        colors[key] = color;
    }
    else {
        throw new Error(`pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`);
    }
    return colors;
}, Object.create(null));
const getColorsEmpty = () => DEFAULT_THEME_KEYS.reduce((colors, key) => {
    colors[key] = { close: '', open: '' };
    return colors;
}, Object.create(null));
const getPrintFunctionName = (options) => options && options.printFunctionName !== undefined ? options.printFunctionName : DEFAULT_OPTIONS.printFunctionName;
const getEscapeRegex = (options) => options && options.escapeRegex !== undefined ? options.escapeRegex : DEFAULT_OPTIONS.escapeRegex;
const getEscapeString = (options) => options && options.escapeString !== undefined ? options.escapeString : DEFAULT_OPTIONS.escapeString;
const getConfig = (options) => ({
    callToJSON: options && options.callToJSON !== undefined ? options.callToJSON : DEFAULT_OPTIONS.callToJSON,
    colors: options && options.highlight ? getColorsHighlight(options) : getColorsEmpty(),
    escapeRegex: getEscapeRegex(options),
    escapeString: getEscapeString(options),
    indent: options && options.min
        ? ''
        : createIndent(options && options.indent !== undefined ? options.indent : DEFAULT_OPTIONS.indent),
    maxDepth: options && options.maxDepth !== undefined ? options.maxDepth : DEFAULT_OPTIONS.maxDepth,
    min: options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
    plugins: options && options.plugins !== undefined ? options.plugins : DEFAULT_OPTIONS.plugins,
    printFunctionName: getPrintFunctionName(options),
    spacingInner: options && options.min ? ' ' : '\n',
    spacingOuter: options && options.min ? '' : '\n',
});
function createIndent(indent) {
    return new Array(indent + 1).join(' ');
}
function format(val, options) {
    if (options) {
        validateOptions(options);
        if (options.plugins) {
            const plugin = findPlugin(options.plugins, val);
            if (plugin !== null) {
                return printPlugin(plugin, val, getConfig(options), '', 0, []);
            }
        }
    }
    const basicResult = printBasicValue(val, getPrintFunctionName(options), getEscapeRegex(options), getEscapeString(options));
    if (basicResult !== null) {
        return basicResult;
    }
    return printComplexValue(val, getConfig(options), '', 0, []);
}
const plugins = {
    ConvertAnsi: plugin$2,
    DOMCollection: plugin$1,
    DOMElement: plugin,
};

exports.default = format;
exports.format = format;
exports.plugins = plugins;
